module.exports = __webpack_public_path__ + "img/43_23.e15e4cda.png";